import _ from "lodash";
import { usePopperTooltip } from "react-popper-tooltip";
import { useWindowSize } from "react-use";
import styled, { css } from "styled-components";
import { CurrentPrice, DisplayPrice, OriginalPrice } from ".";
import withMediaQuery from "../../hooks/useMediaQuery";
import { Helpers } from "../../utils";
import { getBreakpoint } from "../../utils/helpers";
import Icon from "../Icon";
//import 'react-popper-tooltip/dist/styles.css'; // TODO: Replace with custom styles

const ShippingInfoBoxWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles } } }) => css`
    display: flex;
    flex-direction: column;
    padding: 1em;
    
    &:not(:last-child) {
        border-bottom: 0.125em #eee solid;
    } 

    ${ShippingInfoHeader} {
       ${Helpers.clamp('margin-bottom', 0.325, 0.5, 3.25)};
    }

    p {
        color: ${styles.tooltipContent.descriptionColor};
        ${Helpers.clamp('font-size', 0.75, 0.85, 3.25)};
        margin: 0;
        line-height: 1.25;
    }
`)

const ShippingInfoHeader = styled.div<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles } } }) => css`
    display: flex;
    align-items: center;
    gap: 1em;

    strong {
        ${Helpers.clamp('font-size', 0.85, 1, 3.25)};
        color: ${styles.tooltipContent.headingColor};
    }
`)

const ShippingInfoPrices = styled.div<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles } } }) => css`

    display: flex;
    align-items: center;

    ${OriginalPrice},
    ${CurrentPrice} {
        display: flex;
        align-items: center;
        border-radius: 0.25em;
        padding: 0.25em 0.5em;
        ${Helpers.clamp('font-size', 0.625, 0.85, 3.25)};
    }

    ${OriginalPrice} {
        color: ${styles.tooltipContent.originalPriceColor};
        background: ${styles.tooltipContent.originalPriceBackground};
        margin-right: 0.5em;
    }

    ${CurrentPrice} {
        font-weight: 500;
        color: ${styles.tooltipContent.currentPriceColor};
        background: ${styles.tooltipContent.currentPriceBackground};
    }
`)

export const ShippingInfoBox = ({ title, description, prices, config }: any) => {

    const ShippingPrices = withMediaQuery((props: any) => (
        <ShippingInfoPrices {...props}>
            {_.isNumber(prices?.sale) && <DisplayPrice {...config.general} type="original">{(prices?.regular).toFixed(Math.abs(config.general.decimals))}</DisplayPrice>}
            <DisplayPrice {...config.general} type="current">{(prices?.sale ?? prices?.regular).toFixed(Math.abs(config.general.decimals)).replace('.', ',')}</DisplayPrice>
        </ShippingInfoPrices>
    ))

    return (
        <ShippingInfoBoxWrapper>
            <ShippingInfoHeader>
                <strong>{title}</strong>
                {/** width >= 425px (NOTE: Sorry for this unDRY, bad day today...) */}
                <ShippingPrices minWidth={425} />
            </ShippingInfoHeader>
            <p>{description}</p>
            {/** width < 425px (NOTE: Sorry for this unDRY, bad day today...) */}
            <ShippingPrices maxWidth={425} style={{marginTop: '0.25em'}} />
        </ShippingInfoBoxWrapper>
    )
}

const InfoTooltipTriggerWrapper = styled.span<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles } } }) => css`
    /* display: flex;
    align-items: center;
    justify-content: center;

    border-radius: ${`${styles.tooltipTrigger.borderRadius}${_.isNumber(styles.tooltipTrigger.borderRadius) ? 'em' : ''}`};
    background: ${styles.tooltipTrigger.background};
    color: ${styles.tooltipTrigger.iconColor};
    padding: ${styles.tooltipTrigger.size * 0.2}em; */
    
    // width: ${styles.tooltipTrigger.size}em;
    // height: ${styles.tooltipTrigger.size}em;

    /* div, svg {
        width: ${styles.tooltipTrigger.size}em;
        height: ${styles.tooltipTrigger.size}em;
    } */
    svg {
        margin-left: 0.325em;
    }
`)

const InfoTooltipArrow = styled.span<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles } } }) => css`
    position: absolute;
    background: transparent;
    bottom: -1em;
    left: 0;
    width: 10em;
    height: 1em;
`)

const InfoTooltipContainer = styled.div<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles  } } }) => css`
    z-index: 9999999;
    background: #fff;
    position: relative;
    border-radius: 0.5em;
    border: 0.125em #ddd solid;
`)

const InfoTooltipContentWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components: { shippingInfo: styles  } } }) => css`
    padding: 0.25em;
    font-size: 16px;
    position: relative;
    overflow: auto;
    & > div {
        max-height: 32vh;
    }
    @media screen and (max-height: ${getBreakpoint('tablet', 'sm')}) {
        & > div {
            max-height: 25vh;
        }
    }
   
`)

const InfoTooltipLabel = styled.span<any>(() => css`
    border-bottom: 0.1em currentColor solid;
`)

export const InfoTooltip = ({ label, icon, children }: any) => {

    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip({ trigger: 'hover', placement: 'top', interactive: true });

    return (<>
        <InfoTooltipTriggerWrapper ref={setTriggerRef}>
            {label && <InfoTooltipLabel>{label}</InfoTooltipLabel>}
            {icon && <Icon id={icon} />}
        </InfoTooltipTriggerWrapper>
        {visible && (<InfoTooltipContainer ref={setTooltipRef} {...getTooltipProps({ className: 'tooltip-container' })}>
            <InfoTooltipArrow {...getArrowProps()} />
            <InfoTooltipContentWrapper>
                <div>{children}</div>
            </InfoTooltipContentWrapper>
         </InfoTooltipContainer>)
        }
    </>);

}